module.exports = __webpack_public_path__ + "img/sevilla-logo-icon.34d9e92f.png";